import template from './site-operational-status-retailer-list.html';

const mapStateToThis = ({ siteOperationalStatus, config, ui }) => {
  const { retailers, isLoading } = siteOperationalStatus;
  const { defaultPageNo } = config;
  const { sosPagination } = ui;

  return {
    retailers,
    isLoading,
    defaultPageNo,
    pagination: sosPagination,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class SiteOperationalStatusRetailersTableController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class SiteOperationalStatusRetailerListComponent {
  constructor() {
    this.controller = SiteOperationalStatusRetailersTableController;
    this.template = template;
    this.bindings = {
      onRetailerClick: '&',
      gridModel: '<',
      headers: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/site-operational-status/components/site-operational-status-retailer-list/site-operational-status-retailer-list-component.js